import { createElement, Fragment, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useProfile } from '../profile/ProfileProvider';

/**
 * Can the caller use Monthly Mutations? Admin OR hub-admin (HR). Mirrors the
 * server-side `requireMutationAdmin`.
 */
export function useCanManageMutations(): boolean {
  const { state } = useProfile();
  if (state.status !== 'ready') return false;
  if (state.isAdmin) return true;
  if (state.user.hubRole === 'admin' || state.user.hubRole === 'super_admin') return true;
  const email = state.user.email.toLowerCase();
  return (state.config.hubAdminEmails ?? []).map((e) => e.toLowerCase()).includes(email);
}

/** Route guard for Monthly Mutations (admin or hub-admin). */
export function RequireMutationsAccess({ children }: { children: ReactNode }) {
  const { state } = useProfile();
  const ok = useCanManageMutations();
  if (state.status !== 'ready') return null;
  if (!ok) return createElement(Navigate, { to: '/', replace: true });
  return createElement(Fragment, null, children);
}
